(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
class StickyHeader extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.querySelector('.section-header');
    this.headerIsAlwaysSticky =
      this.getAttribute('data-sticky-type') === 'always' ||
      this.getAttribute('data-sticky-type') === 'reduce-logo-size';
    this.headerBounds = {};
      setTimeout(() => {
        this.setHeaderHeight();
      }, 1000);
    this.setHeaderHeight();
    window.addEventListener('load', () => {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    });


    window.matchMedia('(max-width: 1023px)').addEventListener('change', this.setHeaderHeight.bind(this));

    if (this.headerIsAlwaysSticky) {
      this.header.classList.add('shopify-section-header-sticky');
    }

    this.currentScrollTop = 0;
    this.preventReveal = false;
    this.predictiveSearch = this.querySelector('predictive-search');

    this.onScrollHandler = this.onScroll.bind(this);
    this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

    this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.addEventListener('scroll', this.onScrollHandler, false);

    this.createObserver();
    window.addEventListener('scroll', function () {
      const scrollPosition = window.scrollY;
      if (scrollPosition > 100) {
        // document.querySelector('sticky-header').classList.remove('transprent-header');
      } else {
        // document.querySelector('sticky-header').classList.add('transprent-header');
        }
    });

  }

  setHeaderHeight() {
    
    const smallHeader = document.querySelector(".header__logo-wrapperSmall");
    document.documentElement.style.setProperty("--small-header-height", `${smallHeader.offsetHeight}px`);
    document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    setInterval(() => {
      const largeLogo = document.querySelector('.Header__Logo--large'); 
      if (largeLogo) {
        document.documentElement.style.setProperty('--logo-height', `${largeLogo.offsetHeight}px`);
      }
    }, 500); // har 500ms pe check karega

  }
  

  disconnectedCallback() {
    this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.removeEventListener('scroll', this.onScrollHandler);
  }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

    observer.observe(this.header);
  }

  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    // const details = this.querySelectorAll(".header-wrapper details[open]");
    // if (details.length > 0) return;

    // 🔑 Skip hiding if search modal is visible (aria-hidden="false")
    const searchModal = this.header.querySelector("#Search");
    if (searchModal && searchModal.getAttribute("aria-hidden") === "false") return;


    if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

    if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      this.header.classList.add('scrolled-past-header');
      if (this.preventHide) return;
      requestAnimationFrame(this.hide.bind(this));
    } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      this.header.classList.add('scrolled-past-header');
      if (!this.preventReveal) {
        requestAnimationFrame(this.reveal.bind(this));
      } else {
        window.clearTimeout(this.isScrolling);

        this.isScrolling = setTimeout(() => {
          this.preventReveal = false;
        }, 66);

        requestAnimationFrame(this.hide.bind(this));
      }
    } else if (scrollTop <= this.headerBounds.top) {
      this.header.classList.remove('scrolled-past-header');
      this.header.classList.remove('solid-header-transition');
      requestAnimationFrame(this.reset.bind(this));
    }

    this.currentScrollTop = scrollTop;
  }

  hide() {
    
    if (this.headerIsAlwaysSticky) return;
      const details = this.querySelectorAll("header-megamenu details");
      let hasDetailOpen = false;

      details.forEach(detail => {
        if (detail.hasAttribute("open")) {
          hasDetailOpen = true;
        }
      });

      // if(hasDetailOpen == true && window.pageYOffset > 200) return
        this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
        this.header.classList.remove('solid-header-transition');
        this.closeMenuDisclosure();
        this.closeSearchModal();
  }

  reveal() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.add('shopify-section-header-sticky', 'animate');
    this.header.classList.remove('shopify-section-header-hidden');
    this.header.classList.add('solid-header-transition');
  }

  reset() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
  }

  closeMenuDisclosure() {
    this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
    this.disclosures.forEach((disclosure) => disclosure.close());
  }

  closeSearchModal() {
    this.searchModal = this.searchModal || this.header.querySelector('details-modal');
  }
}

customElements.define('sticky-header', StickyHeader);

  document.addEventListener("DOMContentLoaded", function () {
    if (window.scrollY === 0) {
      // console.log("Page is already at the top");
    } else {
      // console.log("Page is not at the top, scrolled:", window.scrollY);
      document.querySelector('.Header__Logo--large.Header__logo').classList.add('animate-logo'); 
    }
  });

  // Big Log JS
  const headerLogo = document.querySelector('.Header__Logo--large');
  const smallHeaderLogo = document.querySelector('.Header__Logo--small.show-with-big-logo');

  // Function to handle scroll events
   function handleScroll() {
    if (window.scrollY > 10) {
      headerLogo.classList.add('animate-logo'); 
      smallHeaderLogo.classList.add('hide-logo');
    } else {
      const megamenuMobile = document.querySelector('.menu-drawer-container');
      if (megamenuMobile.hasAttribute('open')) return;
      headerLogo.classList.remove('animate-logo'); 
      smallHeaderLogo.classList.remove('hide-logo');
    }
  }

  window.addEventListener('scroll', handleScroll);

  } catch(e) { console.error(e); }
})();
})();
